import { render, staticRenderFns } from "./AlgWhatsupIcon.vue?vue&type=template&id=10cdb182&scoped=true&"
import script from "./AlgWhatsupIcon.vue?vue&type=script&lang=js&"
export * from "./AlgWhatsupIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cdb182",
  null
  
)

export default component.exports